
import React from "react";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

const AdminJobs = () => {
  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-2xl font-bold">Jobs</h2>
        <Button>
          <Plus className="h-4 w-4 mr-2" />
          Add Job
        </Button>
      </div>
      
      <div className="bg-muted/30 p-12 rounded-lg text-center">
        <p className="text-xl font-medium">Jobs Management</p>
        <p className="mt-2 text-muted-foreground">
          This component will allow you to create, edit, and manage job listings for teens.
        </p>
      </div>
    </div>
  );
};

export default AdminJobs;
